(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initCollectionDescriptionToggle() {
    const desc = document.querySelector('[class*="text_cVDGHH"]');
    if (!desc || desc.dataset.readMoreInit) return;
    desc.dataset.readMoreInit = 'true';

    const computed = window.getComputedStyle(desc);
    let lineHeight = parseFloat(computed.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) {
      lineHeight = parseFloat(computed.fontSize) * 1.4;
    }
    const twoLineHeight = Math.ceil(lineHeight * 2);

    requestAnimationFrame(() => {
      const fullHeight = desc.scrollHeight;

      if (fullHeight > twoLineHeight + 4) {
        desc.style.maxHeight = twoLineHeight + 'px';
        desc.style.overflow = 'hidden';

        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'collection-description-toggle';
        toggle.textContent = 'Läs mer';

        let expanded = false;
        toggle.addEventListener('click', () => {
          expanded = !expanded;
          if (expanded) {
            desc.style.maxHeight = fullHeight + 'px';
            toggle.textContent = 'Visa mindre';
          } else {
            desc.style.maxHeight = twoLineHeight + 'px';
            toggle.textContent = 'Läs mer';
          }
        });

        desc.insertAdjacentElement('afterend', toggle);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescriptionToggle, { once: true });
  } else {
    initCollectionDescriptionToggle();
  }

  } catch(e) { console.error(e); }
})();
})();
